module.exports = __webpack_public_path__ + "img/ico_alarm_on.419acc64.svg";